import { MaxWidth } from '../Page'
import styled from 'styled-components'
import { ForceFullWidth } from '../InviteCodePage'
import { Box } from '../UI/Box'
import { getRgbaValue } from '../../utils/styling'
import {
  GridPatternBackground,
  NFTRandomText,
} from '../../page_components/Home/Vault/styles'

const DESKTOP_MIN_HEIGHT = 565

type BlurredBackgroundProps = { imageSrc: string; headerHeight: number }

const BlurContainer = styled(Box)`
  position: absolute;
  height: ${DESKTOP_MIN_HEIGHT}px;
  width: 100vw;
`

const BlurredBackground = styled(MaxWidth)<BlurredBackgroundProps>`
  overflow: hidden;
  filter: blur(12px);
  top: ${({ headerHeight }) => -headerHeight * 4}px;
  background: url(${({ imageSrc }) => imageSrc});
  height: ${DESKTOP_MIN_HEIGHT * 1.5}px;
  width: 2600px;
  position: absolute;
  opacity: 0.5;
  .gradient-inner {
    background: radial-gradient(
      50% 88.86% at 50% 0%,
      ${({ theme }) => getRgbaValue(theme.semantics.zap.surface.primary, 0)} 0%,
      ${({ theme }) => getRgbaValue(theme.semantics.zap.surface.primary, 1)}
        100%
    );
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`

const CoreContainer = styled(MaxWidth)`
  z-index: 10;
  position: relative;
  ${NFTRandomText} {
    padding-right: 42px;
    padding-top: 4px;
  }
  @media (max-width: 1000px) {
    width: 100vw;
    padding: 0;
    ${NFTRandomText} {
      display: none;
    }
  }
`

const CoreBackground = styled.div<{ paddingTop: number }>`
  max-width: 1400px;
  min-height: ${DESKTOP_MIN_HEIGHT - 80}px;
  border: 1px solid transparent;
  border-radius: 4px;
  border: 1px solid #353c41;
  z-index: 2;
  .bottom-gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    z-index: 1000;
    min-height: 600px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      ${({ theme }) =>
        getRgbaValue(theme.semantics.zap.surface.primary, 0.96)}90%,
      ${({ theme }) => getRgbaValue(theme.semantics.zap.surface.primary, 1)}100%
    );
  }
  @media (max-width: 1000px) {
    width: 100vw;
    .bottom-gradient {
      min-height: 700px;
    }
  }
`

const BgBanner = styled.div<{ bgImage: string; top: number }>`
  background: url(${({ bgImage }) => bgImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 4px;
  height: 100%;
  max-width: 1400px;
  min-height: ${DESKTOP_MIN_HEIGHT}px;
`

const Outer = styled.div`
  position: absolute;
  width: 100vw;
  top: 0;
  @media (max-width: 1000px) {
    top: -140px;
    z-index: 10;
  }
`

const DoubleHero = ({
  imageSrc,
  headerHeight,
}: {
  imageSrc: string
  headerHeight: number
}) => {
  return (
    <ForceFullWidth>
      <Outer>
        <BlurContainer c pr id="blur-container">
          <Box pr c>
            <BlurredBackground
              imageSrc={imageSrc}
              headerHeight={headerHeight}
              id="blurred-top"
            >
              <div className="gradient-inner" />
            </BlurredBackground>
          </Box>
        </BlurContainer>
        <CoreContainer maxWidth={1400} id="core-container">
          <CoreBackground paddingTop={headerHeight} id="core-background">
            <BgBanner bgImage={imageSrc} top={headerHeight} />
            <div className="bottom-gradient" />
          </CoreBackground>
          <Box dc afe relative z={1000} g={20} alignSelf="flex-end">
            <GridPatternBackground right={0} isOverflow />
            <div className="bottom-grif-gradient" />
          </Box>
          <Box dc afe relative z={1000} g={20} alignSelf="flex-end">
            <NFTRandomText dc afe g={6}>
              <span>
                JASIUKLKDHKJL UYTQL 8513-15894-5645641 JHGTYUJEHKJHE SD'KLJD
              </span>
              <span>9085390678290</span>
            </NFTRandomText>
          </Box>
        </CoreContainer>
      </Outer>
    </ForceFullWidth>
  )
}

export default DoubleHero
